import { createAction } from 'redux-act'

const loading = createAction('Register - Loading')
const success = createAction('Register - Success')
const errors = createAction<any>('Register - Errors')
const additionalInfoAdded = createAction('Addition Info updated')

export default {
  loading,
  success,
  errors,
  additionalInfoAdded,
}
